import Switch from '@components/v2/form/Switch/Switch';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { CopyOrderSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const CopyOrderSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: CopyOrderSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_COPY_ORDER_SETTINGS)}
      description={LangEnum.GENERAL_SETTINGS_COPY_ORDER_SETTINGS_DESCRIPTION}
    >
      <Switch
        label={translate(LangEnum.GENERAL_SETTINGS_COPY_ORDER_WITH_CONDITIONS_SWITCH_LABEL)}
        name="forceCopyOrderWithConditions"
        size="medium"
        sx={{ ml: 0 }}
        checked={generalSettings.forceCopyOrderWithConditions}
        onChange={(_, checked) =>
          handleChangeAndBlur({ value: checked, name: 'forceCopyOrderWithConditions' })
        }
      />
    </SettingContainer>
  );
};

export default CopyOrderSectionGeneralSettings;
